import React from 'react';
import PropTypes from 'prop-types';
import titlecase from 'stringcase/lib/titlecase';

import Modal from '../Modal';
import Form from '../Form';

const EntityCreate = ({
  entityName,
  title,
  backUrlProvider,
  initialValue,
  Input,
  handleCreate,
  history,
  width,
  height,
  onBack,
}) => {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      history.push(backUrlProvider());
    }
  };

  const handleSubmit = async data => {
    await handleCreate(data);
    handleBack();
  };

  return (
    <Modal
      title={title || `New ${titlecase(entityName)}`}
      onClose={handleBack}
      withRouter={false}
      width={width}
      height={height}
    >
      <Form
        autoFocus
        initialValue={initialValue}
        input={Input}
        label={title || 'Create'}
        onSubmit={handleSubmit}
        context={{
          isCreate: true,
          isEdit: false,
        }}
      />
    </Modal>
  );
};

EntityCreate.propTypes = {
  entityName: PropTypes.string.isRequired,
  backUrlProvider: PropTypes.func.isRequired,
  Input: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export default EntityCreate;
